import { ExpressionValue } from "../../ExpressionValue";
import { BaseLogicExpression } from "../Logic/BaseLogic";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { BooleanDataDefinition } from "../../../Common/Data/Definitions/BooleanDataDefinition";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class StringEndWithExpression extends BaseLogicExpression {
    readonly __type: string = "String End With";
    readonly __ruleName: string = "Ends With";

    value1: ExpressionValue;
    value2: ExpressionValue;

    constructor() {
        super();
        this.expressionValueType = new BooleanDataDefinition();
        this.value1 = ExpressionValue.createExpressionValue(this, "value1", new StringDataDefinition());
        this.value2 = ExpressionValue.createExpressionValue(this, "value2", new StringDataDefinition());
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return this.value1.evaluate(data, testContext).endsWith(this.value2.evaluate(data, testContext));
    }
}
